import WebglKyoto from './webgl-kyoto'
import WebglBizarre from './webgl-bizarre'
import WebglBackground from './webgl-background'

(() => {
  const visualCanvas = document.querySelector('.visual-canvas')
  const visualCanvasImg = visualCanvas.querySelector('img')
  const visualLogo1 = document.querySelector('.visual-logo1')
  const visualLogo2 = document.querySelector('.visual-logo2')
  const visualLogo2Img = visualLogo2.querySelector('img')
  new WebglKyoto(visualLogo1)
  new WebglBizarre(visualLogo2, visualLogo2Img)
  new WebglBackground(visualCanvas, visualCanvasImg)
})();

// observer
(() => {
  // #about が画面にはいったら.js-scrollNavigateを消すobserver
  const visual = document.querySelector('.visual')
  const scrollNavigate = document.querySelector('.js-scrollNavigate');
  const about = document.querySelector('#about');
  const options = {
    root: null,
    rootMargin: `99999px 0px 0px`,
    threshold: 0
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visual.classList.add('is-shadow')
        scrollNavigate.classList.add('is-hidden');
      } else {
        visual.classList.remove('is-shadow');
        scrollNavigate.classList.remove('is-hidden');
      }
    });
  }, options);
  observer.observe(about);
})();

(() => {
  // sectionが画面に入ったら.is-visibleを付与するobserver
  const sections = document.querySelectorAll('.js-section');
  const options = {
    root: null,
    rootMargin: '15% 0px -10%',
    threshold: 0.1
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, options);
  sections.forEach(section => {
    observer.observe(section);
  });

})();

(() => {
// リサイズ時ブレイクポイントでリロードする
  const breakPoint = window.matchMedia('(max-width: 760px)')
  breakPoint.addEventListener('change', () => {
    console.log('a');
    location.reload()
  })
})();

// svg sprite
function requireAll(r) {
  r.keys().forEach(r)
}
requireAll(require.context('/src/assets/images/sprite', true, /\.svg$/))
